// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dc2UKOLVU9D6J7qyIB5w {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 32px;
  justify-content: space-between;
  margin-right: 50px;
  margin-top: 4px;
}

.g10C_p_6VDkywUNhQ2xE {
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
}

.te_KygZu9iajIBost4N4 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.HQ0MHoyaMnHnHFHC15XS {
  display: flex;
  align-items: center;
  gap: 4px;
}

.SOc13EwonCHRisknipCA {
  font-family: var(--neutral-3);
  font-family: var(--font-stack-full-medium);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.ZRovBIfnejSOfrPOJ5S0 {
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/HeatmapTitle/HeatmapTitle.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,6BAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".heatmapTitleRoot {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 32px;\n  justify-content: space-between;\n  margin-right: 50px;\n  margin-top: 4px;\n}\n\n.heatmapTitleText {\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n}\n\n.heatmapLegendImages {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.heatmapLegendImageItem {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.heatmapLegendLabel {\n  font-family: var(--neutral-3);\n  font-family: var(--font-stack-full-medium);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.heatmapLegendImg {\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heatmapTitleRoot": `Dc2UKOLVU9D6J7qyIB5w`,
	"heatmapTitleText": `g10C_p_6VDkywUNhQ2xE`,
	"heatmapLegendImages": `te_KygZu9iajIBost4N4`,
	"heatmapLegendImageItem": `HQ0MHoyaMnHnHFHC15XS`,
	"heatmapLegendLabel": `SOc13EwonCHRisknipCA`,
	"heatmapLegendImg": `ZRovBIfnejSOfrPOJ5S0`
};
export default ___CSS_LOADER_EXPORT___;
